import { EnumGoodsDetailIsSpike, EnumSoldOutType } from '../../../defines/enums'

// 一些数据判断方法
/**
 * 判断是否售罄和售罄类型
 * @param {Object} - 接口商品信息
 * @return {IsSoldOutResult}
 */
export const isSoldOut = goods => {
  switch (goods.isSpike) {
    // case EnumGoodsDetailIsSpike.LimitCount:
    // case EnumGoodsDetailIsSpike.LimitTime:
    //   return {
    //     soldOut: goods.is_soldout === 1,
    //     soldOutType:
    //       goods.sold_out_type === 1
    //         ? EnumSoldOutType.Activity
    //         : EnumSoldOutType.Turn,
    //   }
    case EnumGoodsDetailIsSpike.Group:
      return {
        soldOut: goods.singleBalanceLeft === 0 && goods.groupBalanceLeft === 0,
        soldOutType: EnumSoldOutType.Group,
      }
    default:
      return {
        soldOut: goods.balanceLeft === 0,
        soldOutType: EnumSoldOutType.Activity,
      }
  }
}
